import { Form, Button, Select, Table, Row, Col, Checkbox } from "antd";

import CircularProgressBar from "../../../common/CircularProgressBar";
import FormInputRules from "../../../../util/FormInputRules";
import { General } from "../../../../util/General";
import { useAccessControlMaster } from "./index.hook";
import { UserRoleDATA } from "../../../../constants/DatabaseConstants/AuthConstants";
import MasterUtil from "../../../../util/MasterUtil";
import styles from "./index.module.less";
import Loading from "../../../common/Loading";
import { TableHelper } from "../../../../util/TableHelper";
import { Operations } from "../../../../constants/DatabaseConstants/MasterConstant";

import type { ColumnsType } from "antd/lib/table";
import type { ACLMasterRecord } from "../../../../shared/interface/MasterManagement/accessControl.interface";

const AccessControlMaster = () => {
  const config = useAccessControlMaster();

  const renderCheckbox = (operation: Operations) => (text: any, record: ACLMasterRecord) => text !== null && text !== undefined ? <Checkbox checked={text} onChange={() => config.handleCheckboxChange(operation, record)} /> : null;

  const columns: ColumnsType<ACLMasterRecord> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("sr_no")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Module Name",
      dataIndex: "module_name",
      key: "module_name",
      sorter: {
        compare: TableHelper.valueCompare("module_name")
      },
      render: (text) => <div>{text ? MasterUtil.formatModuleName(text) : ""}</div>
    },
    ...[Operations.CREATE, Operations.READ, Operations.UPDATE, Operations.DELETE]?.map((operation) => ({
      align: "center" as any,
      title: operation.charAt(0).toUpperCase() + operation.slice(1),
      dataIndex: `${operation}_action`,
      key: `${operation}_action`,
      render: renderCheckbox(operation),
      width: "7%"
    }))
  ];

  return (
    <>
      {config.roleListLoading && <Loading />}

      {!config.roleListLoading && (
        <Form
          ref={config.formRef}
          style={{
            paddingBottom: "2rem"
          }}
          form={config.form}
          validateTrigger="onBlur"
          colon={false}
          name="register"
          onFinish={config.handleSubmit}
          layout="vertical"
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} lg={8} md={5} xl={5}>
              <Form.Item name="role_id" label="User Role" rules={[FormInputRules.requiredFieldSelectRule("role name")]}>
                <Select getPopupContainer={(trigger) => trigger.parentElement} listHeight={200} showSearch allowClear onChange={config.handleUserRole} className={styles["role-dropdown"]} filterOption={General.searchFilterOnSelect} placeholder="Select user role">
                  {/* Admin role skip to not add admin to access */}
                  {config.roleMasterList
                    ?.filter((item) => item.rolename !== UserRoleDATA.PARI_ADMIN)
                    ?.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.rolename}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {config.loading && <Loading />}
          {!config.loading && <Table className={`gx-table-responsive gx-mt-2 gx-mb-1 ${styles["table"]}`} columns={columns} dataSource={config.dataList} size="middle" pagination={false} bordered />}

          <Form.Item className={`${styles["form-itemFloatR0"]}`}>
            <Button disabled={config.saving || config.roleMasterList?.length === 0 || config.dataList?.length === 0} className="gx-mb-0 gx-mr-5 gx-mt-5 gx-pl-5 gx-pr-5 button-gradiant" htmlType="submit">
              {config.saving ? <CircularProgressBar /> : "Save"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

export default AccessControlMaster;
